import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable, Subscription } from 'rxjs';
import { DatetimeDeviceData } from 'src/app/model/datetime-device';
import { DeviceState, DeviceStatus } from 'src/app/model/device-status';

import { AppState } from 'src/app/store/app.reducer';
import { selectCurrentDatetimeDeviceData, selectCurrentDevice, selectCurrentDeviceStatus, selectIsSupportTimers, selectReadingDatetimeDevice, selectStateDeviceByCommandId4, selectUpdatedDeviceAutomationRtc } from 'src/app/store/device/device.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';
import * as moment from 'moment';
import { Device } from 'src/app/model/device';
import { EDeviceModel, isMtmacModel } from 'src/app/conf/device-models';
import { EDeviceCategory } from 'src/app/conf/device-categories';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { Site } from 'src/app/model/site';
import * as SiteActions from 'src/app/store/site/site.actions';
import { SiteDialogComponent } from 'src/app/modules/sites/components/site-dialog/site.dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-datetime-device',
    templateUrl: './datetime-device.component.html',
    providers: [ConfirmationService, DialogService],
})
export class DatetimeDeviceComponent implements OnInit, OnDestroy {
    deviceStatus$: Observable<DeviceStatus | undefined>;
    deviceStatusSub: Subscription | undefined;
    currentDatetimeDeviceData$: Observable<DatetimeDeviceData | undefined>;
    currentDatetimeDeviceDataSub: Subscription | undefined;
    readingDatetimeDevice$: Observable<boolean | undefined>;
    readingDatetimeDeviceSub: Subscription | undefined;
    device$: Observable<Device | undefined>;
    deviceSub: Subscription | undefined;
    stateDeviceByCommandId$: Observable<DeviceState | undefined>
    stateDeviceByCommandIdSub: Subscription | undefined;
    isSupportTimers$: Observable<boolean | undefined>;
    isSupportTimersSub: Subscription | undefined;
    updatedDeviceAutomationRtc$: Observable<boolean | undefined>;
    updatedDeviceAutomationRtcSub: Subscription | undefined;

    site$: Observable<Site | undefined>;
    siteSub: Subscription | undefined;
    site: Site;

    datetimeData: DatetimeDeviceData = new DatetimeDeviceData();
    configured: boolean;
    online: boolean;
    readingDatetimeDevice: boolean;
    device: Device;
    OPERATION_ID_DATE_TIME = 3;
    COMMAND_ID_DATE_TIME = 4;
    clockPresent: boolean;

    automationDevice: string;
    isSupportTimers = false;
    ref: DynamicDialogRef | undefined;

    constructor(
        private store: Store<AppState>,
        private translate: TranslateService,
        public dialogService: DialogService,
    ) {
        this.initSelectors();
    }

    initSelectors(): void {
        // Store selectors
        this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
        this.currentDatetimeDeviceData$ = this.store.select(selectCurrentDatetimeDeviceData);
        this.readingDatetimeDevice$ = this.store.select(selectReadingDatetimeDevice);
        this.device$ = this.store.select(selectCurrentDevice);
        this.stateDeviceByCommandId$ = this.store.select(selectStateDeviceByCommandId4);
        this.isSupportTimers$ = this.store.select(selectIsSupportTimers);
        this.site$ = this.store.select(selectCurrentSite);
        this.updatedDeviceAutomationRtc$ = this.store.select(selectUpdatedDeviceAutomationRtc);
    }

    ngOnInit(): void {
        this.deviceSub = this.device$?.subscribe(
            (device) => {
                if (device !== undefined && device !== null) {
                    this.device = device;
                }
            }
        );
        this.deviceStatusSub = this.deviceStatus$.subscribe(deviceState => {
            if (deviceState) {
                this.configured = deviceState.Configured === 0;
                this.online = deviceState.Online;
            }
        });
        this.currentDatetimeDeviceDataSub = this.currentDatetimeDeviceData$.subscribe(
            datetimeData => {
                this.datetimeData = datetimeData;
            }
        );
        this.readingDatetimeDeviceSub = this.readingDatetimeDevice$.subscribe(
            readingDatetimeDevice => {
                this.readingDatetimeDevice = readingDatetimeDevice;
            }
        );
        this.updatedDeviceAutomationRtcSub = this.updatedDeviceAutomationRtc$.subscribe(
            updatedDeviceAutomationRtc => {
                if (updatedDeviceAutomationRtc) {
                    this.refreshTime();
                }
            }
        );
        this.stateDeviceByCommandIdSub = this.stateDeviceByCommandId$.subscribe((deviceStateDateTime => {
            if (deviceStateDateTime !== undefined && deviceStateDateTime.OperationId === this.OPERATION_ID_DATE_TIME &&
                deviceStateDateTime.CommandId === this.COMMAND_ID_DATE_TIME) {
                if (deviceStateDateTime.Data !== undefined && deviceStateDateTime.Data.length > 7) {
                    this.clockPresent = true;
                    const year = 2000 + parseInt(deviceStateDateTime.Data[1].toString(16), 10);
                    const month = parseInt(deviceStateDateTime.Data[2].toString(16), 10);
                    const day = parseInt(deviceStateDateTime.Data[3].toString(16), 10);
                    const hour = parseInt(deviceStateDateTime.Data[5].toString(16), 10);
                    const minute = parseInt(deviceStateDateTime.Data[6].toString(16), 10);
                    const second = parseInt(deviceStateDateTime.Data[7].toString(16), 10);
                    this.automationDevice = hour + ':' + minute + ':' + second + ' ' + day + '-' + month + '-' + year;
                } else {
                    this.clockPresent = false;
                }
            }
        }));
        this.isSupportTimersSub = this.isSupportTimers$.subscribe((isSupportTimers => {
            this.isSupportTimers = isSupportTimers;
        }));
        this.siteSub = this.site$?.pipe(
            filter(cs => !!cs)
        ).subscribe((currentSite) => {
            this.site = currentSite;
        });
    }
    /*
    const dec2bcd = (dec) => parseInt(dec.toString(10), 16);
const bcd2dec = (bcd) => parseInt(bcd.toString(16), 10);*/

    ngOnDestroy(): void {
        this.deviceStatusSub?.unsubscribe();
        this.currentDatetimeDeviceDataSub?.unsubscribe();
        this.readingDatetimeDeviceSub?.unsubscribe();
        this.deviceSub?.unsubscribe();
        this.stateDeviceByCommandIdSub?.unsubscribe();
        this.isSupportTimersSub?.unsubscribe();
        this.siteSub?.unsubscribe();
        this.updatedDeviceAutomationRtcSub?.unsubscribe();
    }

    getDatetimeDevice(): void {
        this.store.dispatch(DeviceActions.getDatetimeDevice());
    }

    canGetDatetimeDevice(): boolean {
        return this.configured && this.online;
    }

    getDateTime(): string {
        if (this.isMtmacModel() && this.datetimeData !== null && this.datetimeData !== undefined && this.datetimeData.UtcSeconds !== null) {
            return moment.unix(this.datetimeData.UtcSeconds).format('HH:mm:ss DD-MM-yyyy') + '  ' + this.datetimeData.Tz;
        } else if (this.hasClockTime()) {
            return this.automationDevice;
        }
        return '';
    }

    refreshTime(): void {
        this.store.dispatch(DeviceActions.getStateDeviceByCommandIdReset());
        this.store.dispatch(DeviceActions.getStateDeviceByCommandId({ commandId: 4 }));
    }

    writeRtc(): void {
        this.store.dispatch(DeviceActions.updateDeviceAutomationRtc());
    }

    isMtmacModel(): boolean {
        if (this.device === undefined) {
            return false;
        }
        return isMtmacModel(this.device.ModelId);
    }

    hasClockTime(): boolean {
        if (this.device === undefined) {
            return false;
        }
        return this.hasTimers();
    }

    hasTimers(): boolean {
        return (this.device.CurrentlyOwned) &&
            !this.includeCategories([EDeviceCategory.SubGateway, EDeviceCategory.IntercomSystem]) &&
            !this.isIORS485() && this.isSupportTimers;
    }

    includeCategories(categories: number[]): boolean {
        return categories.includes(this.device.CategoryId);
    }

    isIORS485(): boolean {
        return this.device.ModelId === EDeviceModel.IORS485 || this.device.ModelId === EDeviceModel.GEN_IORS485;
    }


    timezoneNotSet(): boolean {
        if (this.site && (this.site.Timezone === undefined || this.site.Timezone === null || this.site.Timezone === "")) {
            return true;
        }
        return false;
    }


    editSite(): void {
        this.store.dispatch(SiteActions.resetAddEditSiteForm());
        this.ref = this.dialogService.open(SiteDialogComponent, {
            header: this.translate.instant('EDIT_SITE'),
            width: '85vw',
            breakpoints: { '1600px': '98vw' },
            contentStyle: { overflow: 'auto' },
            data: {
                site: this.site
            },
        });
    }
}